import React, { useState, useEffect } from "react";
import Modal from "react-modal";

// Ορίζει ποιο στοιχείο είναι η "ρίζα" της εφαρμογής για το modal
Modal.setAppElement("#root");

const JoinPopup = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  //  Εμφανίζει αυτόματα το popup 1.5 δευτερόλεπτο μετά τη φόρτωση
//  useEffect(() => {
//    const timer = setTimeout(() => setModalIsOpen(true), 1500);
//    return () => clearTimeout(timer);
//  }, []);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  //  Συνδέουμε ένα εξωτερικό κουμπί (αν υπάρχει στη σελίδα)
  useEffect(() => {
    const externalButton = document.getElementById("external-join-btn");
    if (externalButton) {
      externalButton.addEventListener("click", openModal);
      return () => externalButton.removeEventListener("click", openModal);
    }
  }, []);

  return (
    <div>
      {/* Το δικό μας κουμπί */}
      <button
        onClick={openModal}
        style={{
          margin: "20px auto",
          display: "block",
          backgroundColor: "#002D72",
          color: "white",
          border: "none",
          borderRadius: "8px",
          padding: "10px 20px",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      >
        Join Our Team
      </button>

      {/* Το popup */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Join Our Team"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1000,
          },
          content: {
            maxWidth: "400px",
            margin: "auto",
            padding: "30px",
            borderRadius: "12px",
            textAlign: "center",
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
          },
        }}
      >
        <h2>Join Our Team!</h2>
        <p>Choose your area of interest:</p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "15px",
          }}
        >
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeSCsA5c-v2e43B5Rjx0pylyT3bfOU7gy_4nEXTw-9W0xd_gQ/viewform"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#002D72",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Apply for Marketing Team
          </a>

          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdzraBd69mAK5koSYKZMBwMO1HFy4UsWwBDjwth1CKk1hiHQw/viewform"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#002D72",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Apply for Technical Team
          </a>
        </div>

        <button
          onClick={closeModal}
          style={{
            marginTop: "20px",
            backgroundColor: "#ccc",
            border: "none",
            borderRadius: "6px",
            padding: "8px 16px",
            cursor: "pointer",
          }}
        >
          Close
        </button>
      </Modal>
    </div>
  );
};

export default JoinPopup;
